import { jsx } from "react/jsx-runtime";
const WaveformIcon = ({ size, color }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false",
    style: { display: "block" },
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm8 2a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1ZM4 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm16 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z",
        fill: color
      }
    )
  }
);
const CallBennyButton = ({
  disabled = false,
  onClick,
  assistantName = "Benny",
  ctaLabel,
  styles,
  resolveColor
}) => {
  const fg = resolveColor(styles.iconColor);
  const iconSize = styles.iconSize;
  const label = ctaLabel || `Call ${assistantName}`;
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      onClick,
      disabled,
      "aria-label": label,
      title: label,
      className: "tw:p-0 tw:bg-transparent tw:border-none tw:cursor-pointer disabled:tw:cursor-not-allowed tw:transition-colors",
      style: {
        width: iconSize,
        height: iconSize,
        opacity: disabled ? 0.5 : 1
      },
      children: /* @__PURE__ */ jsx(WaveformIcon, { size: iconSize, color: fg })
    }
  );
};
export {
  CallBennyButton
};
//# sourceMappingURL=CallBennyButton.js.map
